import { Component, ChangeDetectionStrategy, computed, inject } from '@angular/core';
import { TranslationService } from '../../services/translation.service';
import { AnimateOnScrollDirective } from '../../directives/animate-on-scroll.directive';

@Component({
  selector: 'app-services',
  templateUrl: './services.component.html',
  imports: [AnimateOnScrollDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesComponent {
  private translationService = inject(TranslationService);
  t = computed(() => this.translationService.t().services);
  
  private serviceImages = [
    'assets/images/service-facade.jpg',
    'assets/images/service-industrial.jpg',
    'assets/images/service-special.jpg'
  ];

  services = computed(() => {
    const serviceTranslations = this.t().items;
    return serviceTranslations.map((item, index) => ({
      ...item,
      imageUrl: this.serviceImages[index]
    }));
  });
}